import { render, staticRenderFns } from "./UserPersonalInformation.vue?vue&type=template&id=4587b820&scoped=true&"
import script from "./UserPersonalInformation.vue?vue&type=script&lang=js&"
export * from "./UserPersonalInformation.vue?vue&type=script&lang=js&"
import style0 from "./UserPersonalInformation.vue?vue&type=style&index=0&id=4587b820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587b820",
  null
  
)

export default component.exports